import React from "react";
import DataTable from "react-data-table-component";
// import Checkbox from "@material-ui/core/Checkbox";

// import ArrowDownward from "@material-ui/icons/ArrowDownward";

// const sortIcon = <ArrowDownward />;
// const selectProps = { indeterminate: (isIndeterminate) => isIndeterminate };

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem", // Change the font size here
      fontWeight: 610, 
      padding:"0px" // Optionally change other styles
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
      // Change the font size of rows here
      // You can also optionally add other row styles here
    },
  },
};

function CustomDataTable({ data = [], ...props }) {
  return (
    <DataTable
      //   pagination
      //   sortIcon={sortIcon}
      customStyles={customStyles}

       /* 🔥 Global Rows Per Page Options */
      paginationRowsPerPageOptions={[
        10, 20, 30, 40, 50, 60,
        100, 200, 300, 400, 500, 1000, // 👈 Adds “Show All”
      ]}

      /* 🔥 Show All Option */
      paginationComponentOptions={{
        selectAllRowsItem: true,
        selectAllRowsItemText: `Show All (${data.length})`,
      }}

            data={data}


      //   dense
      {...props}
    />
  );
}

export default CustomDataTable;
